import { Typography } from "@mui/material";
import { TypographyProps } from "./typography-props";


export default function Subtitle({children, ...props}: TypographyProps) {
  return <Typography variant="subtitle1" {...props}>{children}</Typography>
}